import DeliverySchedulesChart from './DeliverySchedulesChart';
export default DeliverySchedulesChart;
